import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { ReferralCaptureService } from '@shared/lib/referral-capture';

export const refCaptureGuard: CanActivateFn = route => {
  const code = route.queryParamMap.get('code');
  if (code) inject(ReferralCaptureService).save(code);
  return inject(Router).parseUrl('/auth/register');
};
